import { apiRequest } from "@/lib/api-request";
import { bytesToBase64 } from "@/lib/utf8-base64";

// The figures a notebook's `[[img:…]]` markers name, loaded the way an answer on screen loads them: through the
// BFF's image proxy with the person's own session (spark#1252, @adr SPARK-0062-studio-notebooks-export-as-pdf@1).
// react-pdf draws PNG and JPEG only, so any other type counts as a figure that did not load.
const PDF_IMAGE_TYPES = new Set(["image/png", "image/jpeg"]);

async function loadFigure(key: string): Promise<[string, string] | null> {
  try {
    const { response } = await apiRequest(`ai/images/${encodeURIComponent(key)}`);
    const type = (response.headers.get("content-type") ?? "").split(";")[0]!.trim().toLowerCase();
    if (!response.ok || !PDF_IMAGE_TYPES.has(type)) return null;
    const bytes = new Uint8Array(await response.arrayBuffer());
    return bytes.length ? [key, `data:${type};base64,${bytesToBase64(bytes)}`] : null;
  } catch {
    return null;
  }
}

/** The figures that loaded, as data URLs keyed by their marker; one that did not load is simply absent. */
export async function loadNotebookFigures(keys: readonly string[]): Promise<Record<string, string>> {
  const loaded = await Promise.all(keys.map(loadFigure));
  return Object.fromEntries(loaded.filter((entry): entry is [string, string] => entry !== null));
}
